import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';
import { downloadFileFromResponse } from '../util';
import { translate } from '../i18n/customI18nProvider';

const getEventList = async (query=null) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/events' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getEventDetails = async (event_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/events/' + event_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getEventSmartphones = async (event_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/events/' + event_id + '/smartphones', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const putEventSmartphones = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v2/events/' + event_id + '/smartphones', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const validateEventSmartphones = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v2/events/' + event_id + '/smartphones/validate', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const forcePutEventSmartphones = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v2/events/' + event_id + '/smartphones/force', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const exportEventSmartphones = async (event_id) => {
    try {
        let headers = getRequestHeaders();
        let response;

        try {
            response = await axios.get(config.apiUrl + '/v2/events/' + event_id + '/smartphones/export',{ headers, responseType: 'blob' });
        } catch (error) {
            if (error.response) {
                let responseJson = error.response.data;
                alert(translate('custom.unknown_error') + ': ' + responseJson.message);
                return;
            } else {
                throw error;
            }
        }

        if (response.status === 200) {
            await downloadFileFromResponse(response, translate('custom.smartphones') + '.xlsx', true);
        }
    } catch (error) {
        console.log('Error exporting smartphones', error);
        return { error: error.message };
    }
}

const getEventMyposTerminals = async (event_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/events/' + event_id + '/mypos_terminals', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const putEventMyposTerminals = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v2/events/' + event_id + '/mypos_terminals', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const validateEventMyposTerminals = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v2/events/' + event_id + '/mypos_terminals/validate', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const forcePutEventMyposTerminals = async (event_id, payload) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v2/events/' + event_id + '/mypos_terminals/force', payload, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

class EventCash {

    static instance = null;
    cash = new Map();

    constructor() {
        if (EventCash.instance) {
            throw new Error("Use EventCash.getInstance() instead of new.");
        }
        EventCash.instance = this;
    }

    static getInstance() {
        if (!EventCash.instance) {
            EventCash.instance = new EventCash();
        }
        return EventCash.instance;
    }
    
    fetchEventName(eventId) {
        if (this.cash.has(eventId)) {
            return this.cash.get(eventId); 
        }

        const fetchPromise = getEventDetails(eventId)
            .then(eventDetails => {
                if (eventDetails?.event?.name) {
                    return eventDetails.event.name;
                } else {
                    throw new Error(`Event with ID ${eventId} not found.`);
                }
            })
            .catch(error => {
                console.error(`Error fetching event name for ID ${eventId}:`, error);
                this.cash.delete(eventId);
                throw error;
            });

        this.cash.set(eventId, fetchPromise);

        return fetchPromise;
    }
}

export {
    getEventList,
    getEventSmartphones,
    putEventSmartphones,
    validateEventSmartphones,
    forcePutEventSmartphones,
    exportEventSmartphones,
    getEventMyposTerminals,
    putEventMyposTerminals,
    validateEventMyposTerminals,
    forcePutEventMyposTerminals,
    EventCash
}